/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_MY_SHOWS_ITEMS = 'SET_MY_SHOWS_ITEMS';
export const SET_MY_SHOWS_FILTER = 'SET_MY_SHOWS_FILTER';
export const SET_MY_SHOWS_CARET = 'SET_MY_SHOWS_CARET';
export const SET_MY_SHOWS_ITEM_LOADING = 'SET_MY_SHOWS_ITEM_LOADING';
export const SET_MY_SHOWS_PAGE_LOADING = 'SET_MY_SHOWS_PAGE_LOADING';
export const RESET_MYSHOWS = 'RESET_MYSHOWS';
export const SET_MYSHOWS_ERROR = 'SET_MYSHOWS_ERROR';
